/*!

=========================================================
* Paper Kit React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-kit-react

* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/paper-kit-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
<hr style={{ clear: 'both' }} />
*/
import React from "react";

// reactstrap components
import {
  Button,
  Container,
  Row,
  Col,
} from "reactstrap";

// npm components
import { Parallax } from 'react-scroll-parallax';
import { text } from '@storybook/addon-knobs';

// styles
import styles from './../../assets/scss/react/parallax/Parallax.scss';
import "./../../assets/css/img-parallax.css";

function About() {

  window.scrollTo(0, 0);

  const a0 = text('A: x[0]', '-100%');
  const a1 = text('A: x[1]', '-70%');

  const b0 = text('B: x[0]', '100%');
  const b1 = text('B: x[1]', '64%');

  return (
    <>
      <div className="section section-dark section-dark-theme text-center gradient-background-claro">
        <Container>
          <Row className="gradient-title" >
            <Col className="ml-auto mr-auto" md="8">

              <div className="d-none d-sm-block">
                <div className="d-sm-none d-md-block">
                  <div className="d-md-none d-lg-block">
                    <div className="d-lg-none d-xl-block">

                      <Container id="parent3" scrollaxis="vertical" className={styles.elements}>

                        <Parallax id="child3" x={[a0, a1]} className={styles.parallax}>
                          <img alt="char_parallax_1" src={require("assets/img/Index/char_parallax_1.png")} />
                        </Parallax>

                      </Container>

                      <Container id="parent3" scrollaxis="vertical" className={styles.elements}>

                        <Parallax id="child3" x={[b0, b1]} className={styles.parallax}>
                          <img alt="char_parallax_2" src={require("assets/img/Index/char_parallax_2.png")} />
                        </Parallax>

                      </Container>

                    </div>
                  </div>
                </div>
              </div>

              <h2 className="title">The Tournament awaits you!</h2>
              <hr style={{ clear: 'both' }} />
              <h5 className="description" style={{ display: 'inline' }} > MK Defenders of the Earth is a </h5>
              <h5 className="description text-info" style={{ display: 'inline' }} > non-profit fan-game </h5>
              <h5 className="description" style={{ display: 'inline' }} > based on the classic games of the MK saga.
                Powered on Mugen, this game uses Borg117's Season 2 FINAL (PATCH 4) as the base and material of the MKP 4.1 by MKP Team.
              </h5>
              <br />
              <br />
              <br />
            </Col>
          </Row>
          <br />
          <br />
          <Row>
            <Col md="4" style={{ paddingTop: '15px', paddingBottom: '15px' }}>
              <div className="info">
                <div className="icon icon-info">
                  <i className="nc-icon nc-settings-gear-65" />
                </div>
                <div className="description">
                  <h4 className="info-title"> MUGEN 1.1</h4>
                  <p>
                    A Freeware 2D fighting game engine developed by Elecbyte.
                  </p>
                  <Button className="btn-link" color="info" href="http://www.elecbyte.com/mugendocs-11b1/mugen.html">
                    See more
                  </Button>
                </div>
              </div>
            </Col>
            <Col md="4" style={{ paddingTop: '15px', paddingBottom: '15px' }}>
              <div className="info">
                <div className="icon icon-info">
                  <i className="nc-icon nc-controller-modern" />
                </div>
                <div className="description">
                  <h4 className="info-title">Season 2 Final</h4>
                  <p className="description">
                    A powerful engine created by Borg117 for Mortal Kombat games in MUGEN.
                  </p>
                  <Button className="btn-link" color="info" href="https://www.youtube.com/watch?v=9zPfvePBq3I">
                    See more
                  </Button>
                </div>
              </div>
            </Col>
            <Col md="4" style={{ paddingTop: '15px', paddingBottom: '15px' }}>
              <div className="info">
                <div className="icon icon-info">
                  <i className="nc-icon nc-note-03" />
                </div>
                <div className="description">
                  <h4 className="info-title">Free Epic Music</h4>
                  <p>
                    The most professional royalty-free epic music for your live broadcasts.
                  </p>
                  <Button className="btn-link" color="info" href="https://www.youtube.com/c/SergePavkinMusic">
                    SergePavkinMusic
                  </Button>
                  /
                  <Button className="btn-link" color="info" href="https://www.youtube.com/c/ContextSensitive">
                    Evan King
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default About;
